import { render, staticRenderFns } from "./AochenFooter.vue?vue&type=template&id=59144171&scoped=true"
import script from "./AochenFooter.vue?vue&type=script&lang=js"
export * from "./AochenFooter.vue?vue&type=script&lang=js"
import style0 from "./AochenFooter.vue?vue&type=style&index=0&id=59144171&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59144171",
  null
  
)

export default component.exports